import { combineReducers } from "redux";
import trip_locations from "../features/admin/trip_locations/Slice";

const location = combineReducers({
  trip_locations: trip_locations,
});

export default location;
